export default "__VITE_ASSET__f169b21d__"